import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Footer as FooterType } from '../typings'

export const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      strapiFooter {
        id
        logo {
          localFile {
            publicURL
          }
        }
        menu {
          id
          text
          url
        }
      }
    }
  `)

  const footer: FooterType = data.strapiFooter
  const logoUrl: string | undefined = footer.logo?.localFile?.publicURL

  return (
    <footer className="sm:h-14 md:h-16 p-4 sm:px-8 sm:py-0 flex items-center justify-between relative bg-white shadow z-100">
      {logoUrl && <img className="mr-4 md:mr-8 flex-shrink-0" src={logoUrl} alt="Apoverlag" style={{ height: '24px', width: 'auto' }} />}
      <ul className="flex flex-col sm:flex-row gap-2 sm:gap-8 lg:gap-12 text-xs sm:text-sm text-right tracking-wide">
        {footer.menu.map((link) => (
          <li key={link.id}>
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </footer>
  )
}
